import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { ThreeDots } from "react-loader-spinner";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
import { IoChevronDownSharp } from "react-icons/io5";
import { useAuth } from "../../context/Auth";

const UpdateUserModal = ({ show, onClose, user }) => {
    const { requestWithAuth } = useAuth();
    const [data, setData] = useState({});
    
    const [updatingAccount, setUpdatingAccount] = useState(false);
    
    
    
    const [searching, setSearching] = useState(false);
    

    
    useEffect(() => {
        if (user) {
            setData({
                username: user.username || "",
                role: user.role || "",
            });
            
            
            
        }
    }, [user]);

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    };

    const updateUser = async (e) => {
        e.preventDefault();
        try {
            
            const updateData = {
                username: data.username,
                role: data.role
            };

            

            const body = JSON.stringify(updateData);
            setUpdatingAccount(true);
            
            const response = await requestWithAuth(`/accounts/user/${user.id}/`, "PUT", body, {
                "Content-Type": "application/json",
            });
            
            Swal.fire({
                "title": "Account Updated",
                "text": "Account has been updated successfully",
                "icon": "success"
            }).then(() => {
                onClose();
                window.location.reload();
            });
            
        } catch (error) {
            if (error.response?.status !== 400) {
                toast.error("Something unexpected happened. Please try again later.");
            } else {
                toast.error(error.response.data.error);
            }
        } finally {
            setUpdatingAccount(false);
        }
    };

    const handleClose = () => {
        
        setData({});
        onClose();
    };

    
    if (!show || !user) return null;
    
    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={handleClose}
        >
            <div 
                className="bg-white rounded-xl p-6 max-w-md w-full mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 className="text-lg font-semibold mb-4">Update User Account</h3>
                
                <form onSubmit={updateUser} className="space-y-4">
                    <div>
                        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                            Username
                        </label>
                        <input
                            type="text"
                            onChange={handleChange}
                            name="username"
                            id="username"
                            placeholder="Username"
                            value={data.username || ""}
                            required
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>

                    
                    <div>
                        <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1">
                            Role
                        </label>
                        <select 
                            required 
                            name="role" 
                            id="role" 
                            value={data.role || ""}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                            <option value="">Select Role</option>
                            <option value="Admin">
                                Administrator
                            </option>
                            <option value="Administrative Assistant">
                                Administrative Assistant
                            </option>
                            <option value="Finance Manager">
                                Finance Manager
                            </option>
                            <option value="Welfare Manager">
                                Welfare Manager
                            </option>
                        </select>
                    </div>

                    <div className="flex gap-3 justify-end pt-4">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                        >
                            Cancel
                        </button>
                        
                        {updatingAccount ? (
                            <div className="flex items-center justify-center px-4 py-2">
                                <ThreeDots
                                    height="20"
                                    width="40"
                                    radius="9"
                                    color="#2563eb"
                                    ariaLabel="three-dots-loading"
                                    visible={true}
                                />
                            </div>
                        ) : (
                            <button 
                                type="submit"
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                Update User
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateUserModal;